import { Request } from '@/services/api';
import qs from 'qs';

export class SmsTransactionsService {
  static list(query: string) {
    const options = qs.parse(query);
    return Request().get(`/admin/payments${query || ''}`, {
      responseType: options?.download ? 'blob' : 'json',
    });
  }
}
